export type ClipboardImage = {
  src: string;
  name?: string;
  width?: number;
  height?: number;
};

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

function measureImage(src: string): Promise<{ width?: number; height?: number }> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => resolve({});
    img.src = src;
  });
}

export async function readClipboardImage(): Promise<ClipboardImage | null> {
  if (!navigator.clipboard?.read) return null;
  try {
    const items = await navigator.clipboard.read();
    for (const item of items) {
      const type = item.types.find((t) => t.startsWith('image/'));
      if (!type) continue;
      const blob = await item.getType(type);
      const src = await blobToDataUrl(blob);
      const measured = await measureImage(src);
      return {
        src,
        name: `Clipboard image.${type.split('/')[1] || 'png'}`,
        ...measured,
      };
    }
  } catch {
    return null;
  }
  return null;
}

export function fitImageSize(
  natural: { width?: number; height?: number },
  maxWidth = 420,
  maxHeight = 300,
) {
  const width = natural.width ?? 260;
  const height = natural.height ?? Math.round(width * 0.66);
  const scale = Math.min(1, maxWidth / width, maxHeight / height);
  return {
    width: Math.max(80, Math.round(width * scale)),
    height: Math.max(60, Math.round(height * scale)),
  };
}
